import { IFormControl } from '../interfaces';
import React, {ChangeEventHandler, FocusEventHandler, ReactNode, useState} from 'react';
import Select from "react-select";

/**
 * Country & state form fields dependent on each other.
 */
interface ISelectReactFieldProps {
    idPrefix: string,
    label:string,
    // event handlers
    isMulti?: boolean,
    onBlur?: FocusEventHandler,
    onChange?: ChangeEventHandler,
    placeholder?:string,
    options?:IOption[],
    selectIdControl: IFormControl,

    // html content
    comment?: ReactNode,
    // styles
    rootClasses?: string,
    selectClasses?: string,
}
export interface IOption {
    value:number|string,
    label:string
}
const customStyles = {
    control: (base:any, state:any) => ({
        ...base,
        border: state.isFocused ? 0 : 0,
        // This line disable the blue border
        boxShadow: state.isFocused ? 0 : 0,
        '&:hover': {
            border: state.isFocused ? 0 : 0
        }
    })
}
const SelectReactField = (props: ISelectReactFieldProps) => {
    const [hideLabel, setHideLabel] = useState(false);

    const onFocus = () => {
        //hide the label -> when the label is hidden we can see the user's typing
        setHideLabel(true);
    }
    const onBlur = (evnt:any) => {
        if(props.onBlur !== undefined){
            props.onBlur(evnt);
        }
        //onBlur -> show the label again
        setHideLabel(false);
    }
    const onChange = (evnt:any) => {
        if(props.onChange){
            props.onChange(evnt);
        }
        //onChange -> show the label again
        setHideLabel(false);
    }

    return (
        <div className={ props.rootClasses ? props.rootClasses : 'mb-6'}>
            <div className="mb-3">
                <div  className={`w-form-field ${!props.selectIdControl.isValid ? 'w-form-error' : ''} `}>

                    <Select
                        placeholder={props.placeholder? props.placeholder: "Select..."}
                        styles={customStyles}
                        id={ `${ props.idPrefix }` }
                        className={`p-0 w-form-tb ${ props.selectClasses || '' } ${ props.selectIdControl.value ? 'not-empty': '' } `}
                        value={ props.selectIdControl?.value ?? null }
                        onBlur={ onBlur }
                        onFocus={onFocus}
                        onChange={ onChange }
                        options={props.options}
                        isClearable={false}
                        isMulti={props?.isMulti}
                    />
                    {!hideLabel?
                        <label htmlFor={ `${ props.idPrefix }` } className="w-form-label w-3/4">{props.label}</label>
                        :null}
                </div>

                { props.selectIdControl.isValid && props.comment }

                {
                    !props.selectIdControl.isValid && props.selectIdControl.error !== 'This field is required.' &&
                    <div className="text-red text-sm"
                         aria-label={ `${ props.label } error: ${  props.selectIdControl.error }` }
                         role="alert">{ props.selectIdControl.error }</div>
                }
                {
                    !props.selectIdControl.isValid && props.selectIdControl.error === 'This field is required.' &&
                    <div className="text-red text-sm"
                         aria-label={ `${ props.label } error: combo box not selected. ${  props.selectIdControl.error }` }
                         role="alert">{ props.selectIdControl.error }</div>
                }
            </div>


        </div>
    )
};

export default SelectReactField;